export const CLIENTI_PAGE = process.env.NEXT_PUBLIC_CLIENTI_PATH as string;
